import type { IAthleteProfile, ICoachProfile } from 'API/profile'

export type AddableProfileType = 'player' | 'coach' | 'youth'

interface Input {
  athleteProfiles: IAthleteProfile[] | null | undefined
  coachProfile: ICoachProfile | null | undefined
}

export const getAddableProfileTypes = ({ athleteProfiles, coachProfile }: Input): AddableProfileType[] => {
  const list = athleteProfiles ?? []
  const hasPlayer = list.some(a => !a.isManagedByGuardian)
  const hasCoach = !!coachProfile

  const out: AddableProfileType[] = []
  if (!hasPlayer) out.push('player')
  if (!hasCoach) out.push('coach')
  out.push('youth') // Always — guardians can have multiple children
  return out
}

export const PROFILE_TYPE_LABEL: Record<AddableProfileType, string> = {
  player: 'Player',
  coach: 'Coach',
  youth: 'Youth',
}

export const PROFILE_TYPE_DESCRIPTION: Record<AddableProfileType, string> = {
  player: 'I play in a team or league',
  coach: 'I train or manage a team',
  youth: 'Children profile',
}
